import { z } from "zod";

export const MappingEntrySchema = z.object({
  /** Null/absent = element-level (grouped) mapping; set for per-component mappings. */
  componentName: z.string().nullish(),
  elementQualifiedName: z.string(),
  parameterQualifiedName: z.string().nullable(),
  parameterDisplayName: z.string(),
  columnName: z.string(),
});
export type MappingEntry = z.infer<typeof MappingEntrySchema>;

export const MappingScopeKeySchema = z.object({
  componentName: z.string().nullish(),
  elementQualifiedName: z.string(),
});
export type MappingScopeKey = z.infer<typeof MappingScopeKeySchema>;

export const MappingsSavePayloadSchema = z.object({
  entries: z.array(MappingEntrySchema),
  replaceScopes: z.array(MappingScopeKeySchema),
});
export type MappingsSavePayload = z.infer<typeof MappingsSavePayloadSchema>;

export const CompanyElementMappingSchema = MappingEntrySchema.extend({
  companyId: z.string(),
  createdAt: z.string(),
  updatedAt: z.string(),
});
export type CompanyElementMapping = z.infer<typeof CompanyElementMappingSchema>;
